import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import HelpApi from './HelpApi';
import HelpActions from './Components/HelpActions';

let settings;

export default settings = {
    key: 'help',
    zone: 'hosts',
    path: '/help',
    title: "Help",
    endpoint: HelpApi.endpoint,
    modelName: 'Help',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewHelp"],
    viewCaps: ["viewHelp"],
    createCaps: ["createHelp"],
    updateCaps: ["updateHelp"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, user) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            {
                label: "Add New",
                path: settings.path + "/create",
                caps: settings.createCaps
            },
        ];

    },
    indexButtons: (routeName, params, users) => {

        return [
            {
                label: "Add New",
                path: settings.path + '/create',
                caps: settings.createCaps
            }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: HelpApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['topic'], order: ['topicId DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['title'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Title",
                key: "title",
                type: "text",
            },
            {
                label: "Topic",
                key: "topic",
                type: "relationship",
                model: "HelpTopic"
            },
        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            {
                label: "TItle",
                key: "this",
                format: "ModelLink",
            },
            {
                label: "Topic",
                key: "topic",
                format: "modelLink"
            },
            {
                label: "Created Date",
                key: "created",
                format: "OnAndBy",
                sort: "created.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                render: (value, data) => {

                    return <HelpActions data={data} />;

                }
            }
        ];

        return columns;

    },
    singleFetch: HelpApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['topic'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view",
            },
            {
                label: "Edit",
                path: path + "/edit",
                caps: settings.updateCaps
            },
        ]

    },
};